import { render, staticRenderFns } from "./HilightHome.vue?vue&type=template&id=0f70b0dc&"
import script from "./HilightHome.vue?vue&type=script&lang=js&"
export * from "./HilightHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports